import { useTranslation } from 'react-i18next'

import styles from './ContactTourCard.module.scss'
import { ReactComponent as HarbourTourIcon } from './assets/harbour-tour.svg'

interface ContactTourCardProps {
  onTakeFullTour: () => void
}

export const ContactTourCard = ({ onTakeFullTour }: ContactTourCardProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix:
      'desktop.full_page_onboarding.main_screen.steps.contact_person.tour'
  })

  return (
    <section className={styles.card} aria-label={t('title')}>
      <div className={styles.copy}>
        <span className={styles.iconSlot}>
          <HarbourTourIcon className={styles.icon} aria-hidden='true' />
        </span>
        <div className={styles.text}>
          <h3 className={styles.title}>{t('title')}</h3>
          <p className={styles.description}>{t('description')}</p>
        </div>
      </div>
      <button className={styles.button} type='button' onClick={onTakeFullTour}>
        {t('button')}
      </button>
    </section>
  )
}
